import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: {},
};

const ziadost = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.ZIADOST_SAVE_DATA:
      return { ...state, data: { ...state.data, ...action.data } };

    case actionTypes.CHANGE_ZIADOST:
      return { ...state, data: { ...action.data } };

    case actionTypes.CREATE_ZIADOST_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.CREATE_ZIADOST_SUCCESS: {
      return { ...state, isLoading: false };
    }
    case actionTypes.CREATE_ZIADOST_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default ziadost;
